export const SEARCH = {
  UPDATE_SEARCH: 'search/update_search',
  UPDATE_ENABLE_SEARCH: 'search/update_enable_search',
  UPDATE_SHOW_SEARCH_BAR: 'search/update_show_search_bar',
  RESET_SEARCH: 'search/reset_search',
  RECEIVE_SEARCH_TERMS: 'search/receive_search_terms',
  REQUEST_SEARCH_TERMS: 'search/request_search_terms',
  RECEIVE_SEARCH_TERMS_ERROR: 'search/receive_search_terms_error',
};

export const updateSearch = (payload: string) => ({
  type: SEARCH.UPDATE_SEARCH,
  payload,
});

export const updateShowSearchBar = (payload: string) => ({
  type: SEARCH.UPDATE_SHOW_SEARCH_BAR,
  payload,
});

export const updateEnableSearch = (payload: boolean) => ({
  type: SEARCH.UPDATE_ENABLE_SEARCH,
  payload,
});

export const resetSearch = () => ({
  type: SEARCH.RESET_SEARCH,
});

export const receiveSearchTerms = (payload: string[]) => ({
  type: SEARCH.RECEIVE_SEARCH_TERMS,
  payload,
});

export const requestSearchTerms = () => ({
  type: SEARCH.REQUEST_SEARCH_TERMS,
});

export const receiveSearchTermsError = (payload: string) => ({
  type: SEARCH.RECEIVE_SEARCH_TERMS_ERROR,
  payload,
});
